import type { IBreadcrumb } from './interfaces'

/** The part of a TanStack Router match the shell title reads. */
interface IRouteMatchLike {
  pathname: string
  staticData: { title?: string }
}

type TTranslate = (key: string) => string

const withoutTrailingSlash = (pathname: string): string =>
  pathname.length > 1 && pathname.endsWith('/') ? pathname.slice(0, -1) : pathname

/** The translated `staticData.title` of the deepest matched route that has one. */
export function findRouteTitle(matches: readonly IRouteMatchLike[], t: TTranslate): string | undefined {
  for (let index = matches.length - 1; index >= 0; index -= 1) {
    const title = matches[index]?.staticData.title
    if (title) return t(title)
  }

  return undefined
}

/**
 * Crumbs for the routes above the current page: every matched route with a `staticData.title`
 * whose path differs from the current one (a layout route shares its index page's path).
 */
export function buildBreadcrumbs(matches: readonly IRouteMatchLike[], pathname: string, t: TTranslate): IBreadcrumb[] {
  const current = withoutTrailingSlash(pathname)
  const crumbs: IBreadcrumb[] = []

  for (const match of matches) {
    const title = match.staticData.title
    const to = withoutTrailingSlash(match.pathname)

    if (title && to !== current && !crumbs.some((crumb) => crumb.to === to)) crumbs.push({ label: t(title), to })
  }

  return crumbs
}
